import { Component, effect, input, signal } from '@angular/core';
import { PatientBehaviorModel } from '../../core/api/models';
import { SelectItem } from 'primeng/api';
import { StaffApiService, SupervisorApiService } from '../../core/api/services';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { AlertService } from '../../shared/services/alert.service';
import { Utils } from '../../core/utils';
import { Router } from '@angular/router';
@Component({
  selector: 'app-behaviors',
  templateUrl: './behaviors.component.html',
  styleUrl: './behaviors.component.css',
  standalone: false,
})
export class BehaviorsComponent {
  patientID = input.required<string>();

  isLoading: boolean = false;

  behaviors = signal<PatientBehaviorModel[]>([]);
  selectableBehaviors = signal<SelectItem[]>([]);
  selectedBehavior: PatientBehaviorModel | null = null;
  allBehaviorsSelected = signal<boolean>(false);

  constructor(
    private staffApiService: StaffApiService,
    private alertService: AlertService,
    private router: Router
  ) {
    effect(() => {
      if (this.patientID()) {
        this.loadData();
      } else {
        this.router.navigate(['/select-patient']);
      }
    });
  }

  loadData() {
    this.isLoading = true;
    this.staffApiService
      .GetPatientBehaviors({ patientID: Number(this.patientID()) })
      .subscribe(
        (incomingBehaviors) => {
          console.log(incomingBehaviors);
          this.behaviors.set(incomingBehaviors);
          const behaviors = incomingBehaviors.map((behavior) => ({
            text: this.behaviorNameForList(behavior),
            value: behavior.ID,
            disabled: false,
          }));
          // sort behaviors so that deleted and archived behaviors are at the end
          behaviors.sort((a, b) => {
            if (a.text.startsWith('DELETED - ') && !b.text.startsWith('DELETED - ')) {
              return 1;
            } else if (!a.text.startsWith('DELETED - ') && b.text.startsWith('DELETED - ')) {
              return -1;
            } else if (a.text.startsWith('ARCHIVED - ') && !b.text.startsWith('ARCHIVED - ')) {
              return 1;
            } else if (!a.text.startsWith('ARCHIVED - ') && b.text.startsWith('ARCHIVED - ')) {
              return -1;
            }
            return 0;
          });
          behaviors.unshift({
            text: 'All Behaviors',
            value: 0,
            disabled: false,
          });
          this.selectableBehaviors.set(behaviors);
          this.isLoading = false;
        },
        (error) => {
          console.error('Error fetching data', error);
          this.alertService.error(
            Utils.getErrorMessageFromErrorResponse(error)
          );
          this.isLoading = false;
        }
      );
  }

  behaviorNameForList(behavior: PatientBehaviorModel) {
    var name = ""
    if (behavior.IsDeleted) {
      name = "DELETED - ";
    } else if (behavior.IsArchived) {
      name = "ARCHIVED - ";
    }
    return name + (behavior.PatientBehaviorName ? behavior.PatientBehaviorName + ' (' + Utils.patientBehaviorTypeLabel(behavior.BehaviorType!) + ') ' : 'No Name For Target');
  }

  onBehaviorChange(event: MultiSelectChangeEvent) {
    if (event.value == 0) {
      this.allBehaviorsSelected.set(true);
      this.selectedBehavior = null;
    } else {
      this.allBehaviorsSelected.set(false);
      const behavior = this.behaviors().find((behavior) => behavior.ID == event.value);
      if (behavior) {
        this.selectedBehavior = behavior;
      }
    }
  }
}
